import {
  Icon, TextField, Tooltip, Typography,
} from '@gupshup-frontend/gupshup-ts-components';
import { checkTemplateNameFormat } from '../validate';
import { friendlyError } from './errorMessages';

// Console parity (gs-ui-templates/src/containers/Whatsapp/CreateTemplate/config.ts:280,
// TEMPLATE_NAME_MAX_LENGTH) — the console caps input at 200. Our backend DTO
// (create-template.dto.ts, mirrored in Form/validate.js's own TEMPLATE_NAME_REGEX comment) would
// accept up to 250, so 200 is stricter than the wire allows and safe to match here.
const TEMPLATE_NAME_MAX_LENGTH = 200;

// 1. TemplateName — plain TextField, spaces become underscores as you type. Locked in edit mode:
// upstream overwrites this field from the live Meta template on every edit, and UpdateTemplateDto
// rejects the key outright if sent (Form/payload.js already omits it when isEdit) — disabling it
// here just stops the user typing into a field that can never take effect.
const TemplateNameSection = ({ state, dispatch, errors, disabled, isEdit }) => {
  const { value, error: liveError } = state.templateName;
  const submitError = errors['templateName.value'];
  const displayError = liveError || submitError;

  const handleChange = (event) => {
    const next = event.target.value.replace(/ /g, '_');
    dispatch({
      type: 'merge',
      path: 'templateName',
      value: { value: next, error: checkTemplateNameFormat(next) },
    });
  };

  return (
    <div className="br-tpl-form-card" data-testid="bloomreach-templates-form-template-name">
      <div className="br-tpl-form-card-heading-row">
        <div className="br-tpl-form-card-heading">
          <Typography variant="subtitle1" data-testid="bloomreach-templates-form-template-name-heading">
            Template name*
          </Typography>
        </div>
        <Tooltip
          placement="left"
          title="This will not be visible to you but is a required field by WhatsApp for submission"
          data-testid="bloomreach-templates-form-template-name-tooltip"
        >
          <span>
            <Icon name="question" size={18} showCursor />
          </span>
        </Tooltip>
      </div>
      <Typography variant="caption" className="br-tpl-form-helper-text">
        Give your message template a name.
      </Typography>
      <TextField
        fullWidth
        label="Template name"
        value={value}
        onChange={handleChange}
        disabled={disabled || isEdit}
        placeholder="Template name"
        error={Boolean(displayError)}
        // Console parity (TemplateName/index.tsx:76): fall back to the guidance string when
        // there's no error to show. error stays keyed off displayError alone, so the field never
        // renders in the error state while this guidance text is showing.
        helperText={friendlyError(displayError || 'template_names_can_only_contain')}
        autoComplete="off"
        inputProps={{
          maxLength: TEMPLATE_NAME_MAX_LENGTH,
          'data-testid': 'bloomreach-templates-form-template-name-textfield',
        }}
      />
    </div>
  );
};

export default TemplateNameSection;
